// src/firebase.js
// ─────────────────────────────────────────────────────────────
//  STEP 1: Go to https://console.firebase.google.com
//  STEP 2: Create a new project called "fewb-alumni"
//  STEP 3: Add a Web App (</> icon) in Project Settings
//  STEP 4: Copy your firebaseConfig values below
//  STEP 5: In Firebase Console → Firestore Database → Create database (start in test mode)
//  STEP 6: In Firebase Console → Authentication → Sign-in method → Enable Email/Password
//  STEP 7: Create an admin user in Authentication → Users → Add user
// ─────────────────────────────────────────────────────────────

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCTHJ4I4DO9k7PdQ-iAeeALvXXA3MLqGkM",
  authDomain: "fweb-app-b6266.firebaseapp.com",
  projectId: "fweb-app-b6266",
  storageBucket: "fweb-app-b6266.firebasestorage.app",
  messagingSenderId: "1092217652939",
  appId: "1:1092217652939:web:6f3313fbb6b41e09e4bd4e"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export default app;
